var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return (_vm.shouldShowSwitcher)?_c('one-button-toggle',{staticClass:"one-tax-switcher-component",attrs:{"value":_vm.isPriceGross,"is-text":"is-text","active-text":_vm.$t('header.price_gross'),"in-active-text":_vm.$t('header.price_net')},on:{"change":function($event){return _vm.setPriceGross($event)}}}):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }